import React from 'react';
import { ErrorPageProps } from './ErrorPage.types';
import classnames from 'classnames';
import './ErrorPage.scss';
import data from './data.json';
import { Button } from '../Button';

const ErrorPage = ({
  title = '',
  header = 'Something went wrong',
  buttonProps,
  hideLinks = false,
  errorData = data,
}: ErrorPageProps) => {
  const randomSelection = Math.floor(Math.random() * errorData.lineInfo.length);

  if (buttonProps && !buttonProps.value) {
    throw new Error(
      'It seems you are trying to render the button, did you forget to provide button value prop?'
    );
  }

  return (
    <div
      className={classnames([
        'tfl-error-page',
        `tfl-error-page__colours--${errorData.lineInfo[randomSelection].id}`,
      ])}
    >
      <div className="tfl-error-page__inner">
        <div className="tfl-error-page__container">
          {title && <span className="tfl-error-page__title">{title}</span>}
          <h1 className="tfl-error-page__header">{header}</h1>

          {buttonProps ? (
            <div className="tfl-error-page__button">
              <Button {...buttonProps} />
            </div>
          ) : null}

          <div className="tfl-error-page__help-links">
            <div className="tfl-error-page__help-links-panel">
              {!hideLinks && (
                <>
                  <h2 className="tfl-error-page__help-links-panel-header">
                    {errorData.linkPanelHeader}
                  </h2>
                  <ul className="tfl-error-page__help-links-list">
                    {errorData.links.map((link) => (
                      <li
                        key={link.text}
                        className="tfl-error-page__help-links-list-item"
                      >
                        <a
                          href={link.url}
                          className="tfl-error-page__help-link"
                        >
                          {link.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="tfl-error-page__hex-line-name">
        <p className="tfl-error-page__text-line" aria-hidden="true">
          {data.lineInfo[randomSelection].text}
        </p>
        <p className="tfl-error-page__text-hex" aria-hidden="true">
          {data.lineInfo[randomSelection].hex}
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
